import React, { useEffect, useRef, useState } from "react"
import { Tag } from "antd"

export const OneLineTags = ({ tags }: { tags: string[] }) => {
  const measureRef = useRef<HTMLDivElement>(null)
  const [visibleCount, setVisibleCount] = useState(tags.length)
  const [measured, setMeasured] = useState(false)

  useEffect(() => {
    const container = measureRef.current
    if (!container) return

    const children = Array.from(container.children) as HTMLElement[]
    if (children.length === 0) return

    const firstTop = children[0].offsetTop
    let count = 0

    for (const el of children) {
      if (el.offsetTop > firstTop) break
      count++
    }

    setVisibleCount(count)
    setMeasured(true)
  }, [tags])

  const visibleTags = tags.slice(0, visibleCount)
  const hiddenTags = tags.slice(visibleCount)

  return (
    <div>
      {measured ? (
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            overflow: "hidden",
            gap: 4,
            maxHeight: 32,
          }}
        >
          {visibleTags.map((tag, i) => (
            <Tag key={i} color="blue" style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
              {tag}
            </Tag>
          ))}

          {hiddenTags.length > 0 && (
            <Tag color="default" style={{ cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0 }}>
                +{hiddenTags.length}
            </Tag>
          )}
        </div>
      ) : null}
      <div
        ref={measureRef}
        style={{
          visibility: "hidden",
          height: 0,
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          paddingRight: 40,
        }}
      >
        {tags.map((tag, i) => (
          <Tag key={i} color="blue" style={{ whiteSpace: "nowrap" }}>
            {tag}
          </Tag>
        ))}
      </div>
    </div>
  )
}
